import { memo } from 'react';
import EmailIcon from '../EmailIcon';
import svgPaths from '../svgpaths';

/**
 * Lock Icon Component
 */
const LockIcon = memo(() => (
  <div className="relative shrink-0 size-[60px]">
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 60 60">
      <g id="Group 2350">
        <circle cx="30" cy="30" fill="var(--fill-0, #F2F6FA)" id="Ellipse 429" r="30" />
        <mask
          height="32"
          id="mask0_1_43"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
          width="32"
          x="14"
          y="14"
        >
          <rect
            fill="var(--fill-0, #D9D9D9)"
            height="32"
            id="Bounding box"
            width="32"
            x="14"
            y="14"
          />
        </mask>
        <g mask="url(#mask0_1_43)">
          <path d={svgPaths.pec72b80} fill="var(--fill-0, #61B8E7)" id="lock" />
        </g>
      </g>
    </svg>
  </div>
));

LockIcon.displayName = 'LockIcon';

/**
 * Screen Header Component with icon, title and description
 */
export const ScreenHeader = memo(({ icon = 'lock', title, description }) => {
  const IconComponent = icon === 'email' ? EmailIcon : LockIcon;

  return (
    <div className="content-stretch flex flex-col gap-[20px] items-start relative shrink-0 w-full">
      <IconComponent />
      <div className="content-stretch flex flex-col gap-[8px] items-start leading-[normal] relative shrink-0 text-black w-full">
        <p
          className="font-['Roboto:Medium',sans-serif] font-medium relative shrink-0 text-[24px] md:text-[28px] lg:text-[32px] w-full"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          {title}
        </p>
        <p
          className="font-['Roboto:Regular',sans-serif] font-normal relative shrink-0 text-[16px] md:text-[17px] lg:text-[18px] w-full"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          {description}
        </p>
      </div>
    </div>
  );
});

ScreenHeader.displayName = 'ScreenHeader';
